export default {
  state: {
    role: []
  },
  mutations: {
    setRole (state, payload) {
      state.role = payload
    }
  },
  actions: {
    async setRole (ctx) {
      let res = await fetch(`${ctx.getters.getUrlApi}api/admin/directory/user-roles`, {
        headers: {
          Authorization: localStorage.getItem('token')
        }
      })
      res = await res.json()
      ctx.commit('setRole', await res.data)
    }
  },
  getters: {
    getRole (s) {
      return s.role
    }
  }
}
